import config from '../config/logconfig'
const development = process.env.NODE_ENV === 'development'
const levels  = config.levels
const current = config.current
const currentIndex = levels.indexOf(current)

levels.forEach((level, index) => {
    let flag = development || ((currentIndex <= index) && currentIndex !== -1)
    if(!flag) {
        console[level] = _ => {}
    }
})
